export {
  getRegisteredStyles,
  insertStyles,
  registerStyles
} from "./emotion-utils.browser.cjs.js";
